import { render, staticRenderFns } from "./scrolldown-tertiary.vue?vue&type=template&id=fda60820&scoped=true&"
import script from "./scrolldown-tertiary.vue?vue&type=script&lang=js&"
export * from "./scrolldown-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda60820",
  null
  
)

export default component.exports